/* THIS FILE IS GENERATED. DO NOT EDIT IT. */
import * as React from 'react';

function SvgChart48(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={48}
      height={48}
      viewBox='0 0 48 48'
      {...props}
    >
      <g fill='currentColor' fillRule='evenodd' stroke='currentColor'>
        <path d='M44.999 29.76H24.693v-1.74h18.573V5.223H5.194v22.745H3.46V3.493H45V29.76z' />
        <path d='M42.478 40.938h-1.972l-10.844-12.72h1.97l10.846 12.72zM39.19 11.732l-5.017 7.47-4.317-3.897-4.433 7.748-3.43-2.74.932-1.166 2.068 1.648 4.487-7.832 4.414 3.971 4.054-6.035 1.241.833zm-23.854 5.833c2.033.02 3.98 1.235 4.887 3.033a5.586 5.586 0 01.044 4.868c-1.038 2.156-3.575 3.491-6.01 3.024-2.236-.429-4.099-2.38-4.415-4.643a5.606 5.606 0 011.608-4.714 5.578 5.578 0 013.814-1.568h.072zm-.062 1.494c-1.807.016-3.526 1.387-3.906 3.183a4.1 4.1 0 001.125 3.71c1.11 1.083 2.87 1.442 4.324.846 1.284-.525 2.256-1.756 2.458-3.134.249-1.696-.714-3.499-2.28-4.23a4.09 4.09 0 00-1.721-.375zm3.479 10.706c3.435.017 6.806 1.882 8.624 4.821a10.204 10.204 0 011.525 5.363v4.97H1.938c0-1.681-.007-3.355 0-5.037.035-4.13 2.812-8.135 6.806-9.542a10.222 10.222 0 013.315-.575c2.232-.008 4.463 0 6.694 0zm-6.624 1.732c-2.616 0-5.204 1.29-6.777 3.397a8.524 8.524 0 00-1.679 5.055v3.23h23.495c0-1.09.007-2.19 0-3.28-.021-2.706-1.413-5.346-3.624-6.886a8.516 8.516 0 00-4.798-1.516H12.13z' />
        <path d='M38.588 9.64c.954.019 1.778.945 1.639 1.907-.111.787-.852 1.444-1.657 1.444-.926 0-1.76-.888-1.667-1.842.084-.805.815-1.49 1.648-1.509h.037zm-.018 1.5c-.204 0-.195.454.064.343.149-.065.13-.343-.064-.343z' />
      </g>
    </svg>
  );
}

export default SvgChart48;
